import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setTopGuidepostsAction } from "@oldDashboard/legacyActions/dashboardClient";

interface TopPerformingGpProps {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }
const useTopPerformingGp = (props: TopPerformingGpProps) => {
    const { affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchTopGp();
    }, [searching, launchSelected]);


    const fetchTopGp = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getTopGuidePosts(affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate);
            if(response)
                setTopGuidepostsAction(response);
            
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return { isLoading, fetchTopGp}
}

export default useTopPerformingGp;